import {
  BREAKPOINT
} from '../constants';

export function FooterNav(){

  const desktopVal = BREAKPOINT.desktop;
  // Create a MediaQueryList object
  const mediaQuery = window.matchMedia(`screen and (max-width: ${desktopVal}px)`);

  // Check if the media query matches the current viewport
  if (mediaQuery.matches) {
    footerAccordion();
  }

  window.addEventListener('resize', footerAccordion);

  function footerAccordion(){
  // Get all accordion items
    const accordionItems = document.querySelectorAll('.footer-nav .js-accordion-item');

    // Add click event listener to each accordion header
    accordionItems.forEach(item => {
      const header = item.querySelector('.footer-nav .js-accordion-item__header');
      const body = item.querySelector('.footer-nav .js-accordion-item__body');

      header.addEventListener('click', () => {
        header.classList.toggle('is-open');

        if (body.classList.contains('open')) {
          // If accordion content is open, close it with a smooth transition
          slideUp(body);
        } else {
          // If accordion content is closed, open it with a smooth transition
          slideDown(body);
        }
      });
    });

    function slideDown(element) {
      element.style.height = 'auto';
      const height = element.scrollHeight;
      element.style.height = '0';

      setTimeout(() => {
        element.style.height = `${height  }px`;
        element.classList.add('open');
      }, 0);
    }

    function slideUp(element) {
      const height = element.scrollHeight;

      element.style.height = `${height  }px`;

      setTimeout(() => {
        element.style.height = '0';
        element.classList.remove('open');
      }, 0);

      setTimeout(() => {
        element.style.height = '';
      }, 300);
    }
  }



}



// WEBPACK FOOTER //
// ./src/ktu/js/components/FooterNav.js